"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.string.replace.js");

var _react = _interopRequireWildcard(require("react"));

var _objectPath = _interopRequireDefault(require("object-path"));

var _index = _interopRequireDefault(require("../item-list/index.js"));

var _index2 = _interopRequireDefault(require("../slot/index.js"));

var _index3 = _interopRequireDefault(require("../stats-line/index.js"));

var _usePreviousValue = _interopRequireDefault(require("../../hooks/usePreviousValue.js"));

var _gunWrapper = _interopRequireDefault(require("./assets/gun-wrapper.png"));

var _weight = _interopRequireDefault(require("./assets/icons/weight.png"));

var _reset = _interopRequireDefault(require("./assets/icons/reset.png"));

var _discard = _interopRequireDefault(require("./assets/icons/discard.png"));

var _ergonomics = _interopRequireDefault(require("./assets/icons/ergonomics.png"));

var _accuracy = _interopRequireDefault(require("./assets/icons/accuracy.png"));

var _sightingRange = _interopRequireDefault(require("./assets/icons/sighting-range.png"));

var _recoil = _interopRequireDefault(require("./assets/icons/recoil.png"));

var _muzzleVelocity = _interopRequireDefault(require("./assets/icons/muzzle-velocity.png"));

var _typesOfFire = _interopRequireDefault(require("./assets/icons/types-of-fire.png"));

var _fireRate = _interopRequireDefault(require("./assets/icons/fire-rate.png"));

var _caliber = _interopRequireDefault(require("./assets/icons/caliber.png"));

require("./index.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const equipmentSlotsToSlots = equipmentSlot => {
  return {
    type: equipmentSlot._name,
    item: undefined,
    slots: [],
    allowedItems: equipmentSlot._props.filters[0].Filter
  };
};

const getModifierValueFromMods = _ref => {
  var _items$find;

  let {
    targetProperty,
    defaultValue,
    temporaryItemId,
    items,
    slots,
    itemBeingReplaced
  } = _ref;

  if (!temporaryItemId) {
    return defaultValue;
  }

  const candidateItem = ((_items$find = items.find(item => item.id === temporaryItemId)) === null || _items$find === void 0 ? void 0 : _items$find.itemProperties[targetProperty]) || 0;
  let values = slots;

  if (itemBeingReplaced) {
    values = values.filter(slot => {
      var _slot$props$item;

      return ((_slot$props$item = slot.props.item) === null || _slot$props$item === void 0 ? void 0 : _slot$props$item.id) !== itemBeingReplaced.id;
    });
  }

  const newModsValue = values.map(slot => {
    var _slot$props$item2;

    return ((_slot$props$item2 = slot.props.item) === null || _slot$props$item2 === void 0 ? void 0 : _slot$props$item2.itemProperties[targetProperty]) || 0;
  }).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
  return {
    candidateItem,
    newModsValue
  };
};

function TarkovGunBuilder(_ref2) {
  let {
    items,
    presets,
    defaultPresets,
    callback,
    defaultConfiguration,
    availableItemIds
  } = _ref2;
  const [defaultState, setDefaultState] = (0, _react.useState)(defaultConfiguration);
  const [selectedGunId, setSelectedGunId] = (0, _react.useState)(false);
  const [temporaryItemId, setTemporaryItemId] = (0, _react.useState)(false);
  const previousGunId = (0, _usePreviousValue.default)(selectedGunId);
  const [currentBuild, setCurrentBuild] = (0, _react.useState)({
    slots: []
  });
  const [allowedIdsList, setAllowedIdsList] = (0, _react.useState)([]);
  const [listTarget, setListTarget] = (0, _react.useState)();
  const gun = (0, _react.useMemo)(() => {
    return items.find(item => item.id === selectedGunId);
  }, [items, selectedGunId]);
  (0, _react.useEffect)(() => {
    callback({
      gun,
      currentBuild
    });
    setTemporaryItemId();
  }, [gun, currentBuild]);
  (0, _react.useEffect)(() => {
    if (defaultState) {
      setSelectedGunId(defaultState.gun.id);
    }
  }, [defaultState]);
  const gunPresetId = (0, _react.useMemo)(() => {
    if (!gun) {
      return false;
    }

    for (const presetId in defaultPresets) {
      if (gun.id === defaultPresets[presetId].baseId) {
        return presetId;
      }
    }

    return false;
  }, [gun, defaultPresets]);

  const handleSlotSet = (slotIdString, slotAllowedItems) => {
    if (availableItemIds && availableItemIds.length > 0) {
      setAllowedIdsList(slotAllowedItems.filter(slotAllowedItem => availableItemIds.includes(slotAllowedItem)));
    } else {
      setAllowedIdsList(slotAllowedItems);
    }

    console.log(slotAllowedItems);
    setListTarget(slotIdString);
    setTemporaryItemId();
  };

  const handleItemDeselect = keyPrefix => {
    const currentSlots = [...currentBuild.slots];
    const path = keyPrefix.match(/[0-9]+/g);

    const findSlotToReset = (currentSlots, depth) => {
      if (depth + 1 === path.length) {
        return currentSlots[path[depth]];
      } else {
        return findSlotToReset(currentSlots[path[depth]].slots, depth + 1);
      }
    };

    const slot = findSlotToReset(currentSlots, 0);
    delete slot.item;
    delete slot.slots;
    setCurrentBuild(_objectSpread(_objectSpread({}, currentBuild), {}, {
      slots: currentSlots
    }));
  };

  const handleListSelect = itemId => {
    var _targetItem$equipment;

    if (allGuns.includes(itemId)) {
      setSelectedGunId(itemId);
      setAllowedIdsList([]);
      return true;
    }

    console.log("Setting ".concat(listTarget, ".item"));

    const buildCopy = _objectSpread({}, currentBuild);

    const targetItem = items.find(item => item.id === itemId);

    _objectPath.default.set(buildCopy, "".concat(listTarget, ".item"), targetItem);

    _objectPath.default.set(buildCopy, "".concat(listTarget, ".slots"), (_targetItem$equipment = targetItem.equipmentSlots) === null || _targetItem$equipment === void 0 ? void 0 : _targetItem$equipment.map(equipmentSlotsToSlots));

    console.log('New build');
    console.log(buildCopy);
    setCurrentBuild(buildCopy);
    setAllowedIdsList([]);
  };

  const allGuns = (0, _react.useMemo)(() => {
    return items.filter(item => item.types.includes('gun')).map(item => item.id);
  }, [items]);
  (0, _react.useMemo)(() => {
    if (selectedGunId !== previousGunId && gun) {
      var _gun$equipmentSlots;

      const ammoSlot = {
        type: 'mod_chamber',
        item: undefined,
        slots: [],
        allowedItems: gun.allowedAmmoIds
      };
      const defaultBuild = {
        slots: [...((_gun$equipmentSlots = gun.equipmentSlots) === null || _gun$equipmentSlots === void 0 ? void 0 : _gun$equipmentSlots.map(equipmentSlotsToSlots)), ammoSlot]
      };
      const gunPreset = presets[gunPresetId];

      for (const presetItem of gunPreset._items) {
        if (!presetItem.slotId) {
          continue;
        }

        const slot = defaultBuild.slots.find(slot => slot.type === presetItem.slotId);

        if (slot) {
          const slotItem = items.find(item => item.id === presetItem._tpl);
          slot.item = slotItem;

          if (slotItem !== null && slotItem !== void 0 && slotItem.equipmentSlots) {
            slot.slots = slotItem.equipmentSlots.map(equipmentSlotsToSlots);
          }
        }
      }

      if (defaultState) {
        setCurrentBuild(defaultState.currentBuild);
        setDefaultState();
      } else {
        setCurrentBuild(defaultBuild);
      }
    }
  }, [previousGunId, gun, gunPresetId, presets, items]);
  const possibleItemsConflicts = [];

  const getSlot = (slot, keyPrefix) => {
    var _slot$item;

    possibleItemsConflicts.push({
      key: keyPrefix,
      ids: ((_slot$item = slot.item) === null || _slot$item === void 0 ? void 0 : _slot$item.itemProperties.ConflictingItems) || [],
      item: slot.item
    });
    const primarySlot = /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.default, {
      onSelect: handleSlotSet.bind(this, keyPrefix, slot.allowedItems),
      onItemDeselect: handleItemDeselect.bind(this, keyPrefix),
      items: items,
      type: slot.type,
      item: slot.item,
      possibleItemsConflicts: [],
      slotIdentifier: keyPrefix
    }, "".concat(gun.id, "-slot-").concat(keyPrefix));

    if (!slot.slots) {
      return [primarySlot];
    }

    const childSlots = slot.slots.map((innerSlot, index) => {
      return getSlot(innerSlot, "".concat(keyPrefix, ".slots.").concat(index));
    }).flat();
    return [primarySlot, ...childSlots];
  };

  const getSlots = () => {
    return currentBuild.slots.map((slot, index) => {
      return getSlot(slot, "slots.".concat(index));
    }).flat();
  };

  const slots = getSlots();
  let itemBeingReplaced;
  const slotBeingReplaced = slots.find(slot => slot.props.slotIdentifier === listTarget);

  if (slotBeingReplaced) {
    itemBeingReplaced = slotBeingReplaced.props.item;
  }

  slots.forEach(slot => {
    slot.props.possibleItemsConflicts.push(...possibleItemsConflicts);
  });
  let weight = 0;

  if (gun) {
    var _gun$itemProperties;

    weight = (((_gun$itemProperties = gun.itemProperties) === null || _gun$itemProperties === void 0 ? void 0 : _gun$itemProperties.Weight) || 0) + slots.map(slot => {
      var _slot$props$item3, _slot$props$item3$ite;

      return ((_slot$props$item3 = slot.props.item) === null || _slot$props$item3 === void 0 ? void 0 : (_slot$props$item3$ite = _slot$props$item3.itemProperties) === null || _slot$props$item3$ite === void 0 ? void 0 : _slot$props$item3$ite.Weight) || 0;
    }).reduce((a, b) => a + b, 0);
  }

  const ergonomicsModifier = (0, _react.useMemo)(() => {
    return slots.map(slot => {
      var _slot$props$item4;

      return ((_slot$props$item4 = slot.props.item) === null || _slot$props$item4 === void 0 ? void 0 : _slot$props$item4.itemProperties.Ergonomics) || 0;
    }).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
  }, [slots]);
  const temporaryErgonomicsModifier = (0, _react.useMemo)(() => {
    const {
      candidateItem,
      newModsValue
    } = getModifierValueFromMods({
      targetProperty: 'Ergonomics',
      defaultValue: ergonomicsModifier,
      temporaryItemId,
      items,
      slots,
      itemBeingReplaced
    });
    return newModsValue + candidateItem;
  }, [items, slots, temporaryItemId, itemBeingReplaced, ergonomicsModifier]);
  const verticalRecoilModifier = (0, _react.useMemo)(() => {
    const verticalModsRecoil = slots.map(slot => {
      var _slot$props$item5;

      return ((_slot$props$item5 = slot.props.item) === null || _slot$props$item5 === void 0 ? void 0 : _slot$props$item5.itemProperties.Recoil) || 0;
    }).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    const verticalGunRecoil = gun === null || gun === void 0 ? void 0 : gun.itemProperties.RecoilForceUp;
    return verticalGunRecoil + verticalGunRecoil / 100 * verticalModsRecoil;
  }, [slots, gun]);
  const temporaryVerticalRecoilModifier = (0, _react.useMemo)(() => {
    const {
      candidateItem,
      newModsValue
    } = getModifierValueFromMods({
      targetProperty: 'Recoil',
      defaultValue: verticalRecoilModifier,
      temporaryItemId,
      items,
      slots,
      itemBeingReplaced
    });
    const modsRecoil = newModsValue + candidateItem;
    const verticalGunRecoil = gun === null || gun === void 0 ? void 0 : gun.itemProperties.RecoilForceUp;
    return verticalGunRecoil + verticalGunRecoil / 100 * modsRecoil;
  }, [items, slots, temporaryItemId, itemBeingReplaced, verticalRecoilModifier, gun === null || gun === void 0 ? void 0 : gun.itemProperties.RecoilForceUp]);
  const horizontalRecoilModifier = (0, _react.useMemo)(() => {
    const horizontalModsRecoil = slots.map(slot => {
      var _slot$props$item6;

      return ((_slot$props$item6 = slot.props.item) === null || _slot$props$item6 === void 0 ? void 0 : _slot$props$item6.itemProperties.Recoil) || 0;
    }).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    const horizontalGunRecoil = gun === null || gun === void 0 ? void 0 : gun.itemProperties.RecoilForceBack;
    return horizontalGunRecoil + horizontalGunRecoil / 100 * horizontalModsRecoil;
  }, [slots, gun]);
  const temporaryHorizontalRecoilModifier = (0, _react.useMemo)(() => {
    const {
      candidateItem,
      newModsValue
    } = getModifierValueFromMods({
      targetProperty: 'Recoil',
      defaultValue: horizontalRecoilModifier,
      temporaryItemId,
      items,
      slots,
      itemBeingReplaced
    });
    const modsRecoil = newModsValue + candidateItem;
    const horizontalGunRecoil = gun === null || gun === void 0 ? void 0 : gun.itemProperties.RecoilForceBack;
    return horizontalGunRecoil + horizontalGunRecoil / 100 * modsRecoil;
  }, [items, slots, temporaryItemId, itemBeingReplaced, horizontalRecoilModifier, gun === null || gun === void 0 ? void 0 : gun.itemProperties.RecoilForceBack]);
  const defaultMuzzleVelocity = (0, _react.useMemo)(() => {
    var _ammo;

    let ammo;
    const ammoSlot = slots.find(slot => slot.props.type === 'mod_chamber');

    if (ammoSlot !== null && ammoSlot !== void 0 && ammoSlot.props.item) {
      ammo = ammoSlot.props.item;
    } else {
      ammo = items.find(item => (gun === null || gun === void 0 ? void 0 : gun.defAmmo) === item.id);
    }

    return ((_ammo = ammo) === null || _ammo === void 0 ? void 0 : _ammo.initialSpeed) || 0;
  }, [gun, slots, items]);
  const muzzleVelocityModifier = (0, _react.useMemo)(() => {
    const modsPercentageChange = slots.map(slot => {
      var _slot$props$item7;

      return ((_slot$props$item7 = slot.props.item) === null || _slot$props$item7 === void 0 ? void 0 : _slot$props$item7.itemProperties.Velocity) || 0;
    }).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    return defaultMuzzleVelocity + defaultMuzzleVelocity / 100 * modsPercentageChange;
  }, [slots, defaultMuzzleVelocity]);
  const temporaryMuzzleVelocityModifier = (0, _react.useMemo)(() => {
    const {
      candidateItem,
      newModsValue
    } = getModifierValueFromMods({
      targetProperty: 'Velocity',
      defaultValue: muzzleVelocityModifier,
      temporaryItemId,
      items,
      slots,
      itemBeingReplaced
    });
    const modsPercentageChange = newModsValue + candidateItem;
    return defaultMuzzleVelocity + defaultMuzzleVelocity / 100 * modsPercentageChange;
  }, [items, temporaryItemId, defaultMuzzleVelocity, muzzleVelocityModifier, slots, itemBeingReplaced]);
  const accuracyModifier = (0, _react.useMemo)(() => {
    const barrelSlot = slots.find(slot => slot.props.type === 'mod_barrel');
    let centerOfImpact;

    if (barrelSlot !== null && barrelSlot !== void 0 && barrelSlot.props.item) {
      centerOfImpact = barrelSlot.props.item.centerOfImpact;
    } else if (gun !== null && gun !== void 0 && gun.centerOfImpact) {
      centerOfImpact = gun.centerOfImpact;
    } else {
      centerOfImpact = 0;
    }

    return (100 * centerOfImpact / 2.9089).toFixed(2);
  }, [slots]);
  const temporaryAccuracyModifier = (0, _react.useMemo)(() => {
    const temporaryBarrel = items.find(item => item.id === temporaryItemId);

    if (!temporaryBarrel) {
      return;
    }

    return (100 * temporaryBarrel.centerOfImpact / 2.9089).toFixed(2);
  }, [slots]);
  const sightingRangeModifier = (0, _react.useMemo)(() => {
    const maxSightingRange = Math.max(...slots.map(slot => {
      var _slot$props$item8;

      return ((_slot$props$item8 = slot.props.item) === null || _slot$props$item8 === void 0 ? void 0 : _slot$props$item8.itemProperties.sightingRange) || 0;
    }));
    return maxSightingRange;
  }, [slots]);
  const temporarySightingRangeModifier = (0, _react.useMemo)(() => {
    var _items$find2;

    if (!temporaryItemId) {
      return sightingRangeModifier;
    }

    const candidateItem = ((_items$find2 = items.find(item => item.id === temporaryItemId)) === null || _items$find2 === void 0 ? void 0 : _items$find2.itemProperties.sightingRange) || 0;
    let values = slots;

    if (itemBeingReplaced) {
      values = values.filter(slot => {
        var _slot$props$item9;

        return ((_slot$props$item9 = slot.props.item) === null || _slot$props$item9 === void 0 ? void 0 : _slot$props$item9.id) !== itemBeingReplaced.id;
      });
    }

    values = values.map(slot => {
      var _slot$props$item10;

      return ((_slot$props$item10 = slot.props.item) === null || _slot$props$item10 === void 0 ? void 0 : _slot$props$item10.itemProperties.sightingRange) || 0;
    });
    return Math.max(candidateItem, ...values);
  }, [items, temporaryItemId, sightingRangeModifier, slots, itemBeingReplaced]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "tgb-builder-outer-wrapper",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tgb-gun-wrapper",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "tgb-selected-gun-name-wrapper",
        children: (gun === null || gun === void 0 ? void 0 : gun.name) || 'NO GUN SELECTED'
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "tgb-gun-selector-wrapper",
        onClick: () => {
          setListTarget('guns');
          setAllowedIdsList(allGuns);
          setTemporaryItemId();
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tgb-gun-wrapper-top-right",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            className: "tgb-icon",
            src: _gunWrapper.default,
            alt: "wrapper"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tgb-gun-wrapper-bottom-left",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            className: "tgb-icon",
            src: _gunWrapper.default,
            alt: "wrapper"
          })
        }), !gun && /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          children: "CLICK TO SELECT A GUN"
        }), gun && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "tgb-weight-wrapper",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              className: "tgb-icon",
              src: _weight.default,
              alt: "weight-icon"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [weight.toFixed(3), "Kg"]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "tgb-gun-selector-wrapper-image",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              alt: gun.name,
              loading: "lazy",
              src: gun.gridImageLink
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "tgb-actions-wrapper",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "tgb-action",
          onClick: () => {
            setListTarget();
            setTemporaryItemId();
            setSelectedGunId();
            setCurrentBuild({
              slots: []
            });
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            className: "tgb-icon",
            src: _reset.default,
            alt: "discard-icon"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: "Reset"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "tgb-action tgb-irreversible",
          onClick: () => {
            if (gun) {
              var _gun$equipmentSlots2;

              setCurrentBuild({
                slots: [...((_gun$equipmentSlots2 = gun.equipmentSlots) === null || _gun$equipmentSlots2 === void 0 ? void 0 : _gun$equipmentSlots2.map(equipmentSlotsToSlots)), {
                  type: 'mod_chamber',
                  item: undefined,
                  slots: [],
                  allowedItems: gun.allowedAmmoIds
                }]
              });
            }
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            className: "tgb-icon-wide",
            src: _discard.default,
            alt: "discard-icon"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: "Discard Mods"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "tgb-stats-wrapper",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default, {
          min: 0,
          max: 150,
          value: (gun === null || gun === void 0 ? void 0 : gun.itemProperties.Ergonomics) + ergonomicsModifier,
          text: 'Ergonomics',
          iconURL: _ergonomics.default,
          temporaryValue: (gun === null || gun === void 0 ? void 0 : gun.itemProperties.Ergonomics) + temporaryErgonomicsModifier
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default, {
          min: 0,
          max: 35,
          value: accuracyModifier,
          text: 'Accuracy',
          rightText: 'MOA',
          iconURL: _accuracy.default,
          invertColors: true,
          temporaryValue: temporaryAccuracyModifier
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default, {
          min: 0,
          max: 2000,
          text: 'Sighting range',
          value: Math.max(gun === null || gun === void 0 ? void 0 : gun.itemProperties.sightingRange, sightingRangeModifier),
          temporaryValue: temporarySightingRangeModifier,
          iconURL: _sightingRange.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default, {
          min: 0,
          max: 700,
          value: verticalRecoilModifier.toFixed(0) || '-',
          temporaryValue: temporaryVerticalRecoilModifier.toFixed(0),
          invertColors: true,
          text: 'Vertical recoil',
          iconURL: _recoil.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default, {
          min: 0,
          max: 1200,
          value: horizontalRecoilModifier.toFixed(0) || '-',
          temporaryValue: temporaryHorizontalRecoilModifier.toFixed(0),
          invertColors: true,
          text: 'Horizontal recoil',
          iconURL: _recoil.default
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index3.default, {
          min: 0,
          max: 1300,
          value: muzzleVelocityModifier.toFixed(0) || '-',
          text: 'Muzzle velocity',
          rightText: 'm/s',
          iconURL: _muzzleVelocity.default,
          temporaryValue: temporaryMuzzleVelocityModifier.toFixed(0)
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "tgb-grid-container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "tgb-grid-item",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "tgb-horizontal-wrapper",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                className: "tgb-icon",
                src: _typesOfFire.default,
                alt: "types-of-fire-icon"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: "Types of Fire"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "tgb-grid-item-right",
              children: (gun === null || gun === void 0 ? void 0 : gun.itemProperties.weapFireType.join(', ')) || '-'
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "tgb-grid-item",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "tgb-horizontal-wrapper",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                className: "tgb-icon",
                src: _fireRate.default,
                alt: "fire-rate-icon"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: "Fire Rate"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "tgb-grid-item-right",
              children: gun ? "".concat(gun.itemProperties.bFirerate, " rpm") : '-'
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "tgb-grid-item",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "tgb-horizontal-wrapper",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              className: "tgb-icon",
              src: _caliber.default,
              alt: "caliber-icon"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: "Caliber"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "tgb-grid-item-right",
            children: (gun === null || gun === void 0 ? void 0 : gun.itemProperties.ammoCaliber.replace('Caliber', '')) || '-'
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tgb-slots-wrapper",
          children: slots
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "tgb-selector-wrapper",
      children: listTarget && allowedIdsList && allowedIdsList.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default, {
        allowedIdsList: allowedIdsList,
        possibleItemsConflicts: possibleItemsConflicts,
        items: items,
        handleSelect: handleListSelect,
        onHover: id => {
          if (listTarget !== 'guns') {
            setTemporaryItemId(id);
          }
        }
      })
    })]
  });
}

var _default = TarkovGunBuilder;
exports.default = _default;